import './mobile_list_info_component.scss'

import { Controller } from 'stimulus'

export default class extends Controller {
  open () {
    this.element.classList.add('mobile_list_info--opened')
    this.bodyElement.classList.add('body--open_menu')
    this.refreshCuratorsLayout()
  }

  close () {
    this.element.classList.remove('mobile_list_info--opened')
    this.bodyElement.classList.remove('body--open_menu')
  }

  refreshCuratorsLayout () {
    if (this.desktopScreen || this.curatorListController === null) return

    if (this.tocAndCuratorListLessThanMenuHeight) {
      this.curatorListController.stickToBottom()
    } else {
      this.curatorListController.resetPosition()
    }
  }

  get height () {
    return this.element.offsetHeight
  }

  get bodyElement () {
    return document.body
  }

  get tableOfContentsController () {
    return this.application.getControllerForElementAndIdentifier(this.element.querySelector('.table_of_contents'), 'table-of-contents')
  }

  get curatorListController () {
    return this.application.getControllerForElementAndIdentifier(this.element.querySelector('.curator_list'), 'curator-list')
  }

  get tableOfContentsHeight () {
    return this.tableOfContentsController.height
  }

  get curatorListHeight () {
    return this.curatorListController.height
  }

  get desktopScreen () {
    return window.innerWidth >= 1200
  }

  get tocAndCuratorListLessThanMenuHeight () {
    const pixelsBetweenDivs = 10
    return this.tableOfContentsHeight + this.curatorListHeight + pixelsBetweenDivs < this.height
  }
}
